import React, { Component } from 'react';
import loadScripts  from '../../../dassets/js/custom';
import { Link } from 'react-router-dom';

class IssuingHouse extends Component {
  componentDidMount(){
    loadScripts();
  }
  render() {
    return (
      <>
      {/* =================================
    Inner Header */}
    <div className="inner-header bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
            <h1 className="breadcrumb-title mb-0">Issuing House</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
              <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item"><span>Services</span></li>
              <li className="breadcrumb-item active"><span>Issuing House</span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  {/* =================================
  Inner Header */}
  
  
  <section className="space-ptb">
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-xl-3">
          <ul className="list-unstyled vertical-menu border border-2 rounded p-3">
                  <li><Link className="active" to={"/services/issuing-house"}><span>Issuing House</span></Link></li>
                  <li><Link to={"/services/stockbroking"}><span>Stockbroking</span></Link></li>
                  <li><Link to={"/services/financial-advisory"}><span>Financial Advisory</span></Link></li>
                  <li><Link to={"/services/portfolio-management"}><span>Portfolio Management</span></Link></li>
                  <li><Link to={"/services/fund-management"}><span>Fund Management</span></Link></li>
                  <li><Link to={"/services/lagos-commodities-and-future-exchange"}><span>Lagos Commodities and Future Exchange</span></Link></li>
          </ul>
          <div className="bg-dark rounded p-4 mb-md-0 mb-5">
            <span className="lead text-primary fw-bold">Do you have a question? Please contact us</span>
            <h6 className="text-white mt-3">+(234) 0805 555 0606</h6>
            <span className="text-white">info@dynamicportfolio.com</span>
          </div>
        </div>
        <div className="col-md-8 col-xl-9">
          {/* <img className="img-fluid mb-4" src={require("./../../dassets/images/service/10.jpg")} alt=""/> */}
          <div className="mb-md-5 mb-4">
            <h4 className="mb-4">Issuing House</h4>
            <div className='mb-4'>
                  <p>This involves the process of assisting companies, governments and its agencies to raise money from the investing public. It entails the preparation, packaging and marketing of Offers on behalf of institutions seeking to raise funds from the capital market.  In performing this role, Dynamic Portfolio Limited advises on the structure of capital, pricing of securities as well as appropriate timing of Public Issues.  In addition, the firm prepares and files registration statement/application with the Securities and Exchange Commission and The Nigerian Exchange Group. Dynamic also coordinate activities of all parties to the Issue and generally manages Issues from mandate stage until the money is delivered to the Issuer.</p>
                  <p>These include:</p>
                  <ul className="list">
                <li><i className="far fa-circle"></i> Issuance of Public Offers on behalf of corporate clients and government institutions </li>
                <li><i className="far fa-circle"></i> Raising working capital </li>
                <li><i className="far fa-circle"></i> Liasing with regulatory bodies and authorities </li>
              </ul>
                  </div>
          </div>
        </div>
      </div>
    </div>
  </section>
      </>
    );
  }
}

export default IssuingHouse;